import Vue from 'vue'
import Router from 'vue-router'

const Home = () => import('@/components/Home.vue')
import VacancyList from "@/components/Vacancy/vacancyList"
import store from "@/store/store";
import ForCadr from "@/views/cadr/candidateData"
import { TokenService } from '@/services/storage.service'

const Dashboard = () => import("@/views/Dashboard")
import { UserService } from '@/services/user.service'
import ApiService from "@/services/api.service"
import oneId from "@/components/oneId/Index.vue";

Vue.use(Router)

const router = new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    linkActiveClass: 'active link',
    scrollBehavior: () => ({ y: 0 }),
    routes: [
        {
            path: '/',
            name: 'Home',
            component: Home,
            meta: {
                public: true
            }
        },
        {
            path: '/profile',
            name: 'Profile',
            component: Dashboard,
        },
        {
            path: '/vacancy/:id',
            name: 'vacancy',
            component: VacancyList,
            meta: {
                public: true
            }
        },
        {
            path: '/about',
            name: 'about',
            component: () => import(/* webpackChunkName: "about" */ '@/views/About.vue'),
            meta: {
                public: true
            }
        },
        {
            path: '/testResultCandidates',
            name: 'testResultCandidates',
            component: () => import('@/views/cadr/testResultForCandidates'),
            meta: {
                public: true
            }
        },
        {
            path: '/reference/title',
            name: 'ReferenceTitles',
            component: () => import("@/views/references/title/List.vue"),
        },
        {
            name: "oneId",
            path: "/oneid",
            component: oneId,
            meta: {
                public: true, // Allow access to even if not logged in
            },
        },
        {
            path: "*",
            redirect: "/404"
        },
        {
            path: "/404",
            name: "404",
            component: () => import("@/views/404.vue")
        }
    ],

})


const checkProfile = () => {
    return new Promise(async (resolve, reject) => {
        try {
            await store.dispatch("employee/getEmployee")
            if (store.state.employee.employee) {
                resolve("employee")
            } else {
                if (store.state.employee.user == 'admin') {
                    resolve("admin")
                } else {
                    resolve("guest")
                }
            }
        }
        catch (e) {
            reject("guest")
        }
    })
}


const checkHome = async (next) => {
    await store.dispatch("employee/getEmployee")
    if (store.state.employee.employee || store.state.employee.user == 'admin') {
        return next()
    } else {
        await UserService.logout()
        return next()
    }

}
const getPromise = () => {
    return new Promise((resolve) => {
        setTimeout(() => {
            resolve()
        }, 5000);
    })
}
router.beforeEach(async (to, from, next) => {
    const loggedIn = !!TokenService.getToken();
    if (loggedIn && to.name == 'Profile') {
        let user = await checkProfile()
        if (user == "admin" || user == "employee") {
            return next()
        } else {
            return next("/")
        }
    }
    if (loggedIn && to.meta.public) {
        checkHome(next)
    }
    if (!loggedIn && to.name == 'Profile') {
        return next("/")
    }
    if (!loggedIn && to.name == 'ReferenceTitles') {
        return next('/')
    }
    if (loggedIn && to.name == 'ReferenceTitles') {
        let user = await checkProfile()
        if (user == 'admin') {
            return next()
        }
        else {
            return next("/")
        }
    }

    return next();
});

export default router
